<main class="c-main">
    <div class="row">
        <div class="col-md-12"></div>
        <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
            {{ erro }}
        </div>
    </div>
    <div class="mat-elevation-z8">
        <mat-card>
            <mat-card-title>
                <mat-icon>color_lens</mat-icon>
                Perfil
            </mat-card-title>
            <mat-tab-group mat-align-tabs="start" #tabGroup>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon>add</mat-icon>
                        Cadastrar Perfil
                    </ng-template>
                    <mat-card>
                        <form [formGroup]="formulario" (ngSubmit)="submit()">
                            <div class="row">

                                <div class="col-1">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Id</mat-label>
                                        <input matInput formControlName="id" readonly>
                                    </mat-form-field>
                                </div>

                                <div class="col-4">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Nome</mat-label>
                                        <input matInput formControlName="nome" style="text-transform: uppercase;"
                                            required>
                                    </mat-form-field>
                                </div>

                                <div class="col-5">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Descrição</mat-label>
                                        <input matInput formControlName="descricao" style="text-transform: uppercase;"
                                            required>
                                    </mat-form-field>
                                </div>

                                <div class="col-2">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Ativo</mat-label>
                                        <mat-select formControlName="ativo" required>
                                            <mat-option [value]="true">Sim</mat-option>
                                            <mat-option [value]="false">Não</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-md-12">
                                    <div class="row border border-secondary-subtle p-3 m-0">
                                        <!-- TODO: AJUSTAR ENVIO DE permissao para togglePermissao -->
                                        <div *ngFor="let permissao of nomePermissoes" class="col-md-3">
                                            <label>
                                                <input type="checkbox"
                                                    [checked]="formulario.get('permissoes')?.value.includes(getPermissaoPorNome(permissao))"
                                                    (change)="togglePermissao(getPermissaoPorNome(permissao))">
                                                {{ permissao }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row justify-content-between">
                                <div class="col-12 col-md-6">
                                    <!-- habilita desabilita botão com o forma validate -->
                                    <button (click)="limparFormulario()" mat-raised-button>
                                        <mat-icon>insert_drive_file</mat-icon>
                                        Limpar
                                    </button>
                                </div>
                                <div class="col-12 col-md-6" align="right">
                                    <!-- habilita desabilita botão com o forma validate -->
                                    <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                                        <mat-icon>save</mat-icon>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </mat-card>
                </mat-tab>
                                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon>list</mat-icon>
                            Listar Perfis
                        </ng-template>
                        <mat-card>

                            
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Consulta Por</mat-label>
                                        <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                            <mat-option [value]="tipoFiltro"
                                                *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-12 col-md-6">
                                    <mat-form-field class="full-width" appearance="fill" class="w-100">
                                        <mat-label>Parâmetro de Consulta</mat-label>
                                        <input [(ngModel)]="parametroConsulta" name="parametroConsulta" matInput>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 col-md-2">
                                    <button (click)="consultar()" mat-raised-button color="primary"
                                        style="line-height: 51px;width: 100%;">
                                        <mat-icon>search</mat-icon>
                                        Consultar
                                    </button>
                                </div>

                            </div>
                            
                            <!-- //inicio da tabela -->
                            <table mat-table [dataSource]="perfis" class="full-width">
                                <!-- Coluna ID -->
                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let perfil"> {{ perfil.id }} </td>
                                </ng-container>

                                <!-- Coluna Nome -->
                                <ng-container matColumnDef="nome">
                                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                                    <td mat-cell *matCellDef="let perfil"> {{ perfil.nome }} </td>
                                </ng-container>

                                <!-- Coluna descricao -->
                                <ng-container matColumnDef="descricao">
                                    <th mat-header-cell *matHeaderCellDef>Descrição</th>
                                    <td mat-cell *matCellDef="let perfil"> {{ perfil.descricao }} </td>
                                </ng-container>

                                <!-- Coluna preco -->
                                <ng-container matColumnDef="ativo">
                                    <th mat-header-cell *matHeaderCellDef>Ativo</th>
                                    <td mat-cell *matCellDef="let perfil"> {{ perfil.ativo ? "Sim" : "Não" }} </td>
                                </ng-container>

                                
                                <ng-container matColumnDef="editar">
                                    <th mat-header-cell *matHeaderCellDef>Editar</th>
                                    <td mat-cell *matCellDef="let perfil">
                                        <button (click)="preparaEditar(perfil.id)" (click)="tabGroup.selectedIndex = 0"
                                            mat-icon-button color="accent">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                

                                <!-- definir como vai ser as linhas e a ordem das colunas -->
                                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                            </table>

                            <!-- paginação -->
                            <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
                                [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
                                <!-- evento de paginar -->
                            </mat-paginator>

                        </mat-card>
                    </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>

    
</main>